export default __webpack_public_path__ + "static/The Future of Adaptive Learning in Education-ddf8b3b9a3bff07ca360cca79d05d6ed.jpg";